<!-- Секция возможностей - Organism -->
<template>
  <section class="relative py-16 lg:py-24 overflow-hidden" id="features-section">
    <!-- Фоновые элементы -->
    <div class="absolute inset-0 pointer-events-none">
      <!-- Декоративные эллипсы -->
      <div class="absolute bottom-0 right-[212px] w-[456px] h-[456px] opacity-15">
        <div class="bg-gradient-to-br from-primary/20 to-accent/20 rounded-full blur-[100px]" />
      </div>
      <div class="absolute top-[332px] -left-[378px] w-[456px] h-[456px] opacity-10">
        <div class="bg-gradient-to-br from-secondary/20 to-primary/20 rounded-full blur-[100px]" />
      </div>

      <!-- Шумовая текстура -->
      <div class="absolute inset-0 opacity-[0.33]"
        style="background-image: url('/images/noise.svg'); mix-blend-mode: overlay;" />
    </div>

    <div class="relative z-10 mx-auto max-w-7xl px-6">
      <!-- Заголовок секции -->
      <header class="mb-12 lg:mb-16 text-center">
        <h2 class="future-title">
          {{ title }}
        </h2>
      </header>

      <!-- Бенто-сетка с карточками (Desktop) -->
      <div class="features-desktop grid-cols-3 gap-4" style="grid-template-rows: auto auto auto auto auto;">
        <div class="row-span-3 h-fit features-item features-left">
          <img src="/images/block/futures/carear.svg" alt="carear" class="w-full h-auto block" />
        </div>
        <div class="col-start-1 row-start-4 h-fit features-item features-left-delay-1">
          <img src="/images/block/futures/law.svg" alt="law" class="w-full h-auto block" />
        </div>
        <div class="col-start-1 row-start-5 h-fit features-item features-left-delay-2">
          <img src="/images/block/futures/net.svg" alt="net" class="w-full h-auto block" />
        </div>
        <div class="col-span-2 col-start-2 row-start-1 h-fit features-item features-left-delay-1">
          <img src="/images/block/futures/promo.svg" alt="promo" class="w-full h-auto block" />
        </div>
        <div class="col-start-2 row-start-2 h-fit features-item features-left-delay-2">
          <img src="/images/block/futures/royalty.svg" alt="royalty" class="w-full h-auto block" />
        </div>
        <div class="row-span-2 col-start-2 row-start-3 h-fit features-item features-right-delay-1">
          <img src="/images/block/futures/unlim.svg" alt="unlim" class="w-full h-auto block" />
        </div>
        <div class="col-start-2 row-start-5 h-fit features-item features-right-delay-2">
          <img src="/images/block/futures/lable.svg" alt="lable" class="w-full h-auto block" />
        </div>
        <div class="row-span-2 col-start-3 row-start-2 h-fit features-item features-right">
          <img src="/images/block/futures/manager.svg" alt="manager" class="w-full h-auto block" />
        </div>
        <div class="row-span-2 col-start-3 row-start-4 h-fit features-item features-right-delay-1">
          <img src="/images/block/futures/market.svg" alt="market" class="w-full h-auto block" />
        </div>
      </div>

      <!-- Карусель (Mobile) -->
      <div class="features-mobile">
        <div class="features-carousel" ref="carouselRef" @scroll="handleScroll">
          <div class="features-carousel-track">
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mcarear.svg" alt="Карьера" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mpromo.svg" alt="Промо" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mroyalty.svg" alt="Роялти" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/munlim.svg" alt="Безлимит" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mlabel.svg" alt="Лейбл" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mmanager.svg" alt="Менеджер" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mmarketing.svg" alt="Маркетинг" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mlaw.svg" alt="Юридическая поддержка" loading="lazy" decoding="async" />
            </div>
            <div class="features-carousel-slide">
              <img src="/images/block/futures/mnet.svg" alt="Нетворкинг" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>

        <!-- Индикаторы прогресса -->
        <div class="carousel-indicators">
          <div v-for="(_, index) in totalSlides" :key="index" class="carousel-indicator"
            :class="{ 'active': index === activeSlide }" />
        </div>
      </div>

      <!-- CTA кнопка -->
      <div class="text-center mt-12 pt-[2.875rem]">
        <BaseButton tone="light-blue" size="figma" class="btn-header-cta hover:opacity-90" @click="handleCTAClick">
          {{ ctaText }}
          <template #arrow>
            <div class="flex items-center justify-center">
              <svg xmlns="http://www.w3.org/2000/svg" width="11" height="10" viewBox="0 0 11 10" fill="none">
                <path
                  d="M4.63393 0.772284L7.94942 4.08778H0.000109958L0.000109832 5.17982L7.94942 5.17982L4.63393 8.49531L5.40623 9.26762L10.04 4.6338L5.40623 -1.91303e-05L4.63393 0.772284Z"
                  fill="black" />
              </svg>
            </div>
          </template>
        </BaseButton>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue'
import BaseButton from '../atoms/BaseButton.vue'

const title = 'Твои возможности в одной подписке'
const ctaText = 'Попробовать'

const handleCTAClick = () => {
  console.log('CTA clicked')
}

// Карусель
const carouselRef = ref<HTMLElement | null>(null)
const activeSlide = ref(0)
const totalSlides = 9

const handleScroll = () => {
  if (!carouselRef.value) return

  const carousel = carouselRef.value
  const slideWidth = carousel.scrollWidth / totalSlides
  const scrollPosition = carousel.scrollLeft + (carousel.offsetWidth / 2)
  const currentIndex = Math.round(scrollPosition / slideWidth)

  activeSlide.value = Math.min(Math.max(0, currentIndex), totalSlides - 1)
}

// Анимация при скролле
const sectionRef = ref<HTMLElement | null>(null)
const isAnimated = ref(false)

let observer: IntersectionObserver | null = null

onMounted(() => {
  // Наблюдаем за видимостью секции
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !isAnimated.value) {
          console.log('✨ [FeaturesSection] Section is visible - triggering animations')
          isAnimated.value = true

          // Добавляем класс анимации ко всем элементам
          const items = document.querySelectorAll('.features-item')
          items.forEach((item) => {
            item.classList.add('animate-active')
          })
        }
      })
    },
    {
      threshold: 0.2, // Запускаем когда 20% секции видно
      rootMargin: '0px'
    }
  )

  // Находим секцию по id
  const section = document.getElementById('features-section')
  if (section) {
    sectionRef.value = section
    observer.observe(section)
  }
})

onUnmounted(() => {
  if (observer) {
    observer.disconnect()
  }
})
</script>

<style scoped>
.future-title {
  font-family: 'Halvar Breitschrift', sans-serif;
  font-size: 25px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  padding-bottom: 2.25rem;
  background: linear-gradient(109deg, #ECECEC 52.01%, rgba(236, 236, 236, 0.00) 135.73%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@media (min-width: 1024px) {
  .future-title {
    font-size: 40px;
  }
}

/* Desktop: показываем сетку, скрываем карусель */
.features-desktop {
  display: none;
}

.features-mobile {
  display: block;
}

@media (min-width: 1024px) {
  .features-desktop {
    display: grid;
  }

  .features-mobile {
    display: none;
  }
}

/* Карусель для мобильной версии */
.features-carousel {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE и Edge */
}

.features-carousel::-webkit-scrollbar {
  display: none;
  /* Chrome, Safari и Opera */
}

.features-carousel-track {
  display: flex;
  gap: 1rem;
  padding: 0.5rem 0;
}

.features-carousel-slide {
  flex: 0 0 299px;
  width: 299px;
  scroll-snap-align: center;
  border-radius: 1rem;
  overflow: visible;
  cursor: pointer;
}

.features-carousel-slide img {
  width: 299px;
  height: 369px;
  display: block;
  object-fit: cover;
  border-radius: 1rem;
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
    filter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.features-carousel-slide:hover img {
  transform: scale(1.04) translateY(-6px);
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.5));
  will-change: transform, filter;
  /* GPU ускорение только при hover */
}

@media (min-width: 1024px) {
  .features-carousel-slide {
    flex: 0 0 85%;
    width: auto;
    max-width: 400px;
  }

  .features-carousel-slide img {
    width: 100%;
    height: auto;
  }
}

/* Snap-скролл для плавной прокрутки */
.features-carousel {
  scroll-snap-type: x mandatory;
  scroll-padding: 1.5rem;
}

/* Адаптивные размеры на планшетах */
@media (min-width: 640px) and (max-width: 1024px) {
  .features-carousel-slide {
    flex: 0 0 340px;
    width: 340px;
  }

  .features-carousel-slide img {
    width: 340px;
    height: 420px;
  }
}

/* Индикаторы карусели */
.carousel-indicators {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  margin-top: 1.5rem;
  padding: 0 1rem;
}

.carousel-indicator {
  height: 4px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex: 1;
  max-width: 32px;
}

.carousel-indicator.active {
  background: rgba(255, 255, 255, 0.8);
  max-width: 48px;
}

/* Скрываем индикаторы на десктопе */
@media (min-width: 1024px) {
  .carousel-indicators {
    display: none;
  }
}

/* Анимации для картинок в бенто-сетке */
@keyframes features-fade-in-left {
  from {
    opacity: 0;
    transform: translateX(-100px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes features-fade-in-right {
  from {
    opacity: 0;
    transform: translateX(100px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.features-item {
  opacity: 0;
  animation-fill-mode: forwards;
  animation-play-state: paused;
  cursor: pointer;
}

.features-item img {
  display: block;
  width: 100%;
  height: auto;
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1),
    filter 0.35s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.features-item:hover img {
  transform: scale(1.04) translateY(-6px);
  filter: drop-shadow(0 20px 30px rgba(0, 0, 0, 0.5));
  will-change: transform, filter;
  /* GPU ускорение только при hover */
}

/* Анимации запускаются только при добавлении класса animate-active */
.features-item.animate-active.features-left {
  animation: features-fade-in-left 1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  animation-play-state: running;
}

.features-item.animate-active.features-right {
  animation: features-fade-in-right 1s cubic-bezier(0.4, 0, 0.2, 1) forwards;
  animation-play-state: running;
}

.features-item.animate-active.features-left-delay-1 {
  animation: features-fade-in-left 1s cubic-bezier(0.4, 0, 0.2, 1) 0.1s forwards;
  animation-play-state: running;
}

.features-item.animate-active.features-left-delay-2 {
  animation: features-fade-in-left 1s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards;
  animation-play-state: running;
}

.features-item.animate-active.features-right-delay-1 {
  animation: features-fade-in-right 1s cubic-bezier(0.4, 0, 0.2, 1) 0.1s forwards;
  animation-play-state: running;
}

.features-item.animate-active.features-right-delay-2 {
  animation: features-fade-in-right 1s cubic-bezier(0.4, 0, 0.2, 1) 0.2s forwards;
  animation-play-state: running;
}
</style>